// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".prefooter[data-v-0e72b737]{padding-top:5rem;padding-bottom:3.75rem}@media only screen and (min-width: 960px){.prefooter[data-v-0e72b737]{padding-top:10rem;padding-bottom:7.5rem}}", ""]);
// Exports
module.exports = exports;
